import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    cancel: string;
    confirmationInstructions: (confirmationText: string) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Button to cancel the delete confirmation and close the dialog */
            cancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DeleteConfirmation.cancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Instruction prompting the user to type the confirmation text to proceed with deletion */
            confirmationInstructions: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (confirmationText: string) => __intl__.intl().formatMessage({ id: "DeleteConfirmation.confirmationInstructions?c=1h26d9n268i9n", defaultMessage: "Type \"{confirmationText}\" to confirm" }, { confirmationText: confirmationText }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
